// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"673":"b2c486ea","767":"72ffb5f5"}[chunkId] + ".chunk.js";
};